import { counted, plural } from '../plural';
import type { Messages } from '../shape';

export const inspector = {
  tabs: {
    outline: 'Структура',
    links: 'Ссылки',
    tags: 'Теги',
    history: 'История',
    share: 'Доступ',
  },

  outline: {
    section: (count: number) => `Структура · ${count}`,
    locked: 'Ключа от этой заметки на устройстве нет, поэтому нет и её структуры.',
    empty:
      'Заголовков пока нет. Начните строку с # — и она появится здесь, с отступом под той, что выше.',
  },

  links: {
    backlinks: (count: number) => `Обратные ссылки · ${count}`,
    empty: 'Сюда пока ничто не ведёт. Напишите [[заголовок]] в другой заметке.',
    hidden: (count: number) =>
      `Ещё ${counted(count, ['заметка', 'заметки', 'заметок'])} ${plural(count, ['ссылается', 'ссылаются', 'ссылаются'])} сюда из мест, которых вы не видите. Число честное, а имена принадлежат не вам.`,
    out: (count: number) => `Исходящие ссылки · ${count}`,
    unresolved: (count: number) =>
      `${counted(count, ['ссылка', 'ссылки', 'ссылок'])} в этой заметке ${plural(count, ['не ведёт', 'не ведут', 'не ведут'])} ни к чему, что вы можете открыть:`,
    unresolvedTail:
      'Несовпавшие заголовки остаются на этом устройстве — отправить их значит опубликовать текст.',
  },

  tags: {
    section: (count: number) => `Теги · ${count}`,
    empty: 'Тегов пока нет. Они запечатаны вместе с именем заметки, поэтому сервер их не видит.',
    add: 'Добавить тег',
    remove: (tag: string) => `Убрать тег ${tag}`,
    inText: (count: number) => `В тексте · ${count}`,
    inTextNote: 'Эти написаны в самой заметке. Чтобы изменить их, правьте текст.',
  },

  history: {
    section: (count: number) => `Версии · ${count}`,
    empty: 'Сохранённых версий пока нет.',
    removedAuthor: 'удалённый аккаунт',
    version: (seq: number) => `Версия ${seq}`,
    locked: 'Ключа от этой версии у вас нет.',

    signatureOk: 'Подпись верна',
    signatureBad: 'Подпись не совпадает',
    authorUnknown: 'Автор неизвестен',
    unsigned: 'Без подписи',
  },

  share: {
    section: (count: number) => `Публичные ссылки · ${count}`,
    denied: 'Опубликовать эту заметку может только тот, кто ею управляет.',
    lede: 'Любой, у кого есть ссылка, прочитает копию этой заметки такой, какая она сейчас. Секрет лежит в той части адреса, которую браузер никогда не отправляет, поэтому сервер хранит только дайджест и не может открыть то, что отдаёт, — а сама ссылка несёт лишь эту заметку, но не ключ от папки, в которой она лежит.',
    frozen:
      'Включён режим только для чтения: отсюда заметку не опубликовать, а уже выданные ссылки не отозвать.',
    publish: 'Опубликовать эту версию',
    shownOnce: 'Показываем один раз',
    copy: 'Копировать ссылку',
    live: 'Активна',
    revoked: 'Отозвана',
    expired: 'Истекла',
    views: (count: number) => counted(count, ['просмотр', 'просмотра', 'просмотров']),
    revoke: 'Отозвать',
  },
} satisfies Messages['inspector'];
